<template>
    <div class="container">
      <div v-if="isLoading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <div class="loading-text">Loading...</div>
      </div>
      <h1>Holiday Master Management</h1>
      <table>
        <thead>
          <tr>
            <th>Holiday Name</th>
            <th>Fixed Date</th>
            <th>Holiday Logic</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="holiday in holidays" :key="holiday.id">
            <td>{{ holiday.holiday_name }}</td>
            <td>{{ holiday.fixed_date }}</td>
            <td>{{ holiday.holiday_logic }}</td>
          </tr>
        </tbody>
      </table>

      <h2>Add New Holiday</h2>
      <div class="form-inline">
        <input placeholder="Holiday Name" v-model="newHoliday.holiday_name">
        <input type="date" placeholder="Fixed Date" v-model="newHoliday.fixed_date">
        <button @click="addHoliday">Add Holiday</button>
      </div>
    </div>
  </template>

<script>
import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

export default {
  data () {
    return {
      holidays: [],
      newHoliday: {
        holiday_name: '',
        fixed_date: '',
        loadingCount: 0
      }
    }
  },
  created () {
    this.fetchHolidays()
  },
  computed: {
    isLoading () {
      return this.loadingCount > 0
    }
  },
  methods: {
    startLoading () {
      this.loadingCount++
    },

    finishLoading () {
      this.loadingCount = Math.max(this.loadingCount - 1, 0)
    },

    withLoading (request) {
      this.startLoading()

      return request()
        .finally(() => {
          this.finishLoading()
        })
    },
    getAuthHeaders () {
      const token = localStorage.getItem('authToken')

      return {
        Authorization: `Bearer ${token}`
      }
    },
    fetchHolidays () {
      this.withLoading(() => this.withLoading(() => axios.get(`${API_BASE_URL}/manage-holidays`, {
        headers: this.getAuthHeaders()
      })))
        .then(response => {
          this.holidays = response.data
        })
        .catch(error => {
          console.error('Error fetching holidays:', error)
        })
    },
    addHoliday () {
      if (!this.newHoliday.holiday_name || !this.newHoliday.fixed_date) {
        alert('Please fill in all fields')
        return
      }

      this.withLoading(() => axios.post(`${API_BASE_URL}/manage-holidays`, this.newHoliday, {
        headers: this.getAuthHeaders()
      }))
        .then(() => {
          alert('Holiday added successfully')
          this.fetchHolidays()
          this.newHoliday = { holiday_name: '', fixed_date: '' }
        })
        .catch(error => {
          console.error('Error adding holiday:', error)
        })
    }
  }
}
</script>

  <style scoped>
  .container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: 'Arial', sans-serif;
  }

  h1, h2 {
    text-align: center;
    margin-bottom: 20px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }

  th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  th {
    background-color: #f4f4f4;
  }

  input[type="text"], input[type="date"] {
    width: calc(100% - 16px);
    padding: 8px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  button {
    padding: 10px 20px;
    margin: 10px 5px;
    font-size: 16px;
    cursor: pointer;
    border: none;
    background-color: #4CAF50;
    color: white;
    border-radius: 4px;
  }

  button:hover {
    background-color: #45a049;
  }

  .form-inline {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .form-inline input {
    flex: 1;
  }

  .form-inline button {
    flex: none;
  }

  </style>
